import { useOnlineStatus } from "@/hooks/use-online-status";
import { useState, useEffect } from "react";
import { OfflinePage } from "./OfflinePage";
import { OfflineIndicator } from "./OfflineIndicator";

interface ConnectivityGateProps {
  children: React.ReactNode;
}

export function ConnectivityGate({ children }: ConnectivityGateProps) {
  const isOnline = useOnlineStatus();
  const [wasInitiallyOnline, setWasInitiallyOnline] = useState(false);

  useEffect(() => {
    if (isOnline) {
      setWasInitiallyOnline(true);
    }
  }, [isOnline]);

  if (!wasInitiallyOnline && !isOnline) {
    return <OfflinePage />;
  }

  return (
    <>
      <OfflineIndicator />
      {children}
    </>
  );
}
